import { render, staticRenderFns } from "./contentModal.vue?vue&type=template&id=85a1bbf8&scoped=true"
import script from "./contentModal.vue?vue&type=script&lang=js"
export * from "./contentModal.vue?vue&type=script&lang=js"
import style0 from "./contentModal.vue?vue&type=style&index=0&id=85a1bbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a1bbf8",
  null
  
)

export default component.exports